import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'intrasense-single-spinner',
  templateUrl: './single-spinner.component.html',
  styleUrls: ['./single-spinner.component.scss']
})
export class SingleSpinnerComponent implements OnInit {
  @Input() visible: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
